/*
 * The english translation of SocialCaptionsPanel
 */
export const SOCIAL_CAPTIONS_PANEL_EN = {
  publishCaption: 'Publish',
  copy: 'Copy',
  noContent: 'No content, please try again',
  generateAdditionalComTask: 'Generate additional ComTask'
}

/*
 * The german translation of SocialCaptionsPanel
 */
export const SOCIAL_CAPTIONS_PANEL_DE = {
  publishCaption: 'Veröffentlichen',
  copy: 'Kopieren',
  noContent: 'Kein Inhalt, versuche es erneut',
  generateAdditionalComTask: 'Weitere ComTasks generieren'
}
